<script lang="ts" setup>
import { CircleHelp, icons } from '@lucide/vue';

const props = withDefaults(defineProps<{
    name?: string | null;
    size?: number | string;
    strokeWidth?: number | string;
}>(), {
    name: null,
    size: 16,
    strokeWidth: 1.5
});

const iconClasses = computed(() =>
{
    const tokens = props.name?.trim().split(/\s+/).filter(Boolean) || [];

    return tokens.slice(1);
});

const icon = computed(() =>
{
    const normalized = normalizeIconName(props.name);
    const component = normalized ? (icons as Record<string, any>)[normalized] : null;

    return component || CircleHelp;
});

function normalizeIconName(value?: string | null)
{
    if (!value)
        return '';

    const [iconName] = value.trim().split(/\s+/);

    return iconName
        .split(/[^a-zA-Z0-9]+/)
        .filter(Boolean)
        .map(part => `${part.charAt(0).toUpperCase()}${part.slice(1)}`)
        .join('');
}
</script>

<template>
    <component
        :is="icon"
        :size="size"
        :stroke-width="strokeWidth"
        :class="iconClasses"
        v-bind="$attrs"
    />
</template>
